module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCsos),
      expression: "showCsos"
    }]
  }, [(_vm.showCsos) ? _c('router-view') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b405dc7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 608
// module chunks = 4 5 6